import React, { ReactNode } from 'react';
import { Button as NativeButton } from '@mantine/core';
import classes from './LightButton.module.css';

export const LightButton = (props: {
	onClick?: () => void;
	children?: ReactNode;
	size?: string;
	variant?: string;
	color?: string;
	fullWidth?: boolean;
	loading?: boolean;
	disabled?: boolean;
	leftSection?: React.ReactNode;
	visibleFrom?: string;
	hiddenFrom?: string;
}) => {
	return (
		<NativeButton classNames={classes} {...props}>
			{props.children}
		</NativeButton>
	);
};
